<template>
  <div>
    <layout-default>
      <div class="container mb-4">
        <breadcrumb class="mt-5">
          <link-wrapper
            location="/"
            class="breadcrumb-text text-decoration-none"
          >
            <span class="breadcrumb-home">Inicio</span>
            <span class="breadcrumb-text mx-2"> / </span>
          </link-wrapper>
          <link-wrapper
            location="/admin/auctions"
            class="breadcrumb-text text-decoration-none"
          >
            <span class="breadcrumb-home">Remates</span>
            <span class="breadcrumb-text mx-2"> / </span>
          </link-wrapper>
          <link-wrapper location="/admin/auctions/new">
            <span class="breadcrumb-text text-decoration-none"
              >Nuevo Remate</span
            >
          </link-wrapper>
        </breadcrumb>
      </div>
      <div class="my-5">
        <section class="container col-12 col-md-8 products">
          <div class="d-flex justify-content-center">
            <!-- Card Info Group -->
            <card class="mx-auto">
              <template v-slot:title>
                <b>
                  {{ $route.params.id ? "Editar Producto" : "Nuevo Producto" }}
                </b>
              </template>
              <template v-slot:body>
                <auction-form />
              </template>
            </card>
          </div>
        </section>
      </div>
    </layout-default>
  </div>
</template>

<script>
import Card from "@/components/molecules/Card/Card.vue";
import Breadcrumb from "@/components/atoms/Breadcrumb/Breadcrumb.vue";
import LayoutDefault from "@/components/organisms/LayoutDefault/LayoutDefault.vue";
import auctionForm from "@/components/custom/auction/form.vue";
import LinkWrapper from "@/components/atoms/LinkWrapper/LinkWrapper.vue";

export default {
  name: "AdminProductsNew",
  middleware: ["auth", "admin"],
  components: {
    auctionForm,
    LayoutDefault,
    Card,
    Breadcrumb,
    LinkWrapper,
  },
  mounted() {
    document.title = "Agregar Remate";
  },
};
</script>
